/**
 * Navigation functionality
 *
 * @package WPCore
 */

export function initNavigation() {
	// Scroll to section khi URL có hash (vd: /#pricing, /plans#pricing)
	if (window.location.hash) {
		const target = document.querySelector(window.location.hash);
		if (target) {
			setTimeout(() => {
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 200);
		}
	}

	const mobileMenuToggle = document.querySelectorAll('.mobile-menu-toggle');
	const mobileMenu = document.querySelector('#mobile-navigation');
	const mobileOverlay = document.querySelector('#mobile-menu-overlay');
	const body = document.body;

	const toggleElements = Array.from(mobileMenuToggle).filter(
		(el) => el instanceof Element
	);

	if (!toggleElements.length || !(mobileMenu instanceof Element)) {
		return;
	}

	const lockBodyForDrawer = () => {
		const pad = window.innerWidth - document.documentElement.clientWidth;
		if (pad > 0) {
			document.documentElement.style.paddingRight = `${pad}px`;
		}
		body.classList.add('overflow-hidden');
	};

	const unlockBodyForDrawer = () => {
		document.documentElement.style.paddingRight = '';
		body.classList.remove('overflow-hidden');
	};

	const isMobileMenuOpen = () => !mobileMenu.classList.contains('hidden');

	const hamburgerSvg =
		'<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>';
	const closeSvg =
		'<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>';

	/** Đồng bộ mọi .mobile-menu-toggle theo trạng thái drawer (không đọc aria-expanded của từng nút — tránh lệch sau đóng bằng overlay/link). */
	const syncToggleUi = () => {
		const open = isMobileMenuOpen();
		toggleElements.forEach(toggle => {
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			const icon = toggle.querySelector('svg');
			if (icon) {
				icon.innerHTML = open ? closeSvg : hamburgerSvg;
			}
		});
	};

	const openMobileMenu = () => {
		mobileMenu.classList.remove('hidden');
		lockBodyForDrawer();
		if (mobileOverlay) {
			mobileOverlay.classList.add('is-active');
		}
		syncToggleUi();
	};

	/** Link chính của mục WP (li.menu-item): phần tử <a> con trực tiếp đầu tiên — không dùng :scope (Safari cũ / edge cases). */
	const getPrimaryItemLink = (item) => {
		if (!item) {
			return null;
		}
		for (let i = 0; i < item.children.length; i++) {
			const ch = item.children[i];
			if (ch instanceof HTMLAnchorElement && ch.hasAttribute('href')) {
				return ch;
			}
		}
		return null;
	};

	const closeMobileMenu = () => {
		mobileMenu.classList.add('hidden');
		unlockBodyForDrawer();
		if (mobileOverlay) {
			mobileOverlay.classList.remove('is-active');
		}
		syncToggleUi();
	};

	// Toggle mobile menu — luôn derive từ class hidden trên #mobile-navigation, mọi nút cùng sync
	toggleElements.forEach(toggle => {
		toggle.addEventListener('click', (e) => {
			e.stopPropagation();
			if (isMobileMenuOpen()) {
				closeMobileMenu();
			} else {
				openMobileMenu();
			}
		});
	});

	syncToggleUi();

	// Đóng khi chọn mục (/#…, /, trang khác). Capture chạy trước bubble — tránh mất sự kiện do stopPropagation.
	const onMobileNavActivate = (e) => {
		const from = e.target instanceof Element ? e.target : e.target.parentElement;
		if (!from || typeof from.closest !== 'function') {
			return;
		}
		const item = from.closest('.menu-item');
		if (!item || !mobileMenu.contains(item)) {
			return;
		}
		let anchor = getPrimaryItemLink(item);
		if (!anchor && typeof from.closest === 'function') {
			anchor = from.closest('a');
		}
		if (!anchor || !mobileMenu.contains(anchor)) {
			return;
		}
		const primary = getPrimaryItemLink(item);
		const isSubmenuParentToggle =
			item.classList.contains('menu-item-has-children') &&
			primary &&
			anchor === primary &&
			window.innerWidth < 1024;
		if (isSubmenuParentToggle) {
			return;
		}
		closeMobileMenu();
	};
	mobileMenu.addEventListener('click', onMobileNavActivate, true);

	window.addEventListener('hashchange', () => {
		closeMobileMenu();
	});

	// Close mobile menu on escape key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !mobileMenu.classList.contains('hidden')) {
			closeMobileMenu();
		}
	});

	// Close mobile menu when clicking overlay
	if (mobileOverlay) {
		mobileOverlay.addEventListener('click', () => {
			if (!mobileMenu.classList.contains('hidden')) {
				closeMobileMenu();
			}
		});
	}

	// Close mobile menu when clicking outside
	document.addEventListener('click', (e) => {
		const target = e.target;
		if (!(target instanceof Node)) {
			return;
		}
		const isClickOnToggle = toggleElements.some(toggle => toggle.contains(target));
		if (!mobileMenu.classList.contains('hidden') &&
			!mobileMenu.contains(target) &&
			!isClickOnToggle &&
			!(mobileOverlay instanceof Element && mobileOverlay.contains(target))) {
			closeMobileMenu();
		}
	});

	// Submenu toggles — chỉ trong drawer mobile, tránh bind nhầm #primary-menu
	const menuItemsWithChildren = mobileMenu.querySelectorAll('.menu-item-has-children');
	menuItemsWithChildren.forEach(item => {
		const link = getPrimaryItemLink(item);
		if (link) {
			link.addEventListener('click', (e) => {
				// Only on mobile
				if (window.innerWidth < 1024) {
					e.preventDefault();
					item.classList.toggle('is-open');
				}
			});
		}
	});

	// Sticky header
	const header = document.querySelector('.site-header');

	if (header) {
		window.addEventListener('scroll', () => {
			const currentScroll = window.pageYOffset;

			if (currentScroll > 100) {
				header.classList.add('scrolled');
			} else {
				header.classList.remove('scrolled');
			}
		});
	}
}
